<!-- Form to raise a ticket-->
<!-- Loader -->
<ng-container *ngIf = "loading">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</ng-container>
<!-- end of Loader -->
<!-- Check for user authorization -->
<ng-container *ngIf="!loading">
  <ng-container *ngIf="role && role !== 'CUSTOMER'">
    <h1>UNAUTHORISED ACCESS</h1> <br>
    <h3>Please Login as CUSTOMER, redirecting ...</h3>
    {{unauthorised()}}
  </ng-container>

  <ng-container *ngIf="serverErrorMessages">
    <div class="alert alert-danger" role="alert">
      {{ serverErrorMessages }}
    </div>
  </ng-container>
  <!-- form to enter ticket details -->
  <ng-container *ngIf="role && role === 'CUSTOMER'">
    <div class="wrapper ">
      <div>
        <br><br><br>
        <div class="content">
          <div class="container-fluid form">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="card-5">
                        <div class="card-body">
                            <h2 class="card-title text-center">How may we help you? <br>Please enter your issue in detail in the space below.</h2>
                            <br><br>
                            <div>
                                <div id="errorMsg" *ngIf="serverErrorMessages">
                                    <span>{{serverErrorMessages}}</span>
                                </div>
                                <div id="successMsg" *ngIf="successMessage">
                                    <span>{{successMessage}}</span>
                                </div>
                                <form
                                  #raiseTicketForm="ngForm"
                                  (ngSubmit)="raiseTicketForm.valid && onSubmit(raiseTicketForm)">
                                  
                                  <div>
                                    <br>
                                    <div class="value">
                                      <div class="input-group">
                                        <textarea class="input--style-5"
                                          type="text"
                                          #issue="ngModel"
                                          class="form-control"
                                          (ngModel)="issue"
                                          name="issue"
                                          placeholder="ENTER TEXT HERE"
                                          required
                                          [ngClass]="{ 'invalid-textbox': raiseTicketForm.submitted && !issue.valid }"
                                        >
                                      </textarea>
                                        <div *ngIf="raiseTicketForm.submitted && issue.errors">
                                          <label *ngIf="issue.errors.required" class="validation-message">
                                          This field is required.
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <br><br>
                                  <div style="text-align: center;">
                                    <input type="submit" class="btn btn-primary" style="border-radius: 18px; position: center;" value="Raise Ticket"/>
                                  </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
<!-- end of form to raise ticket -->